let current;

export const saveEditProgress = (data = {}) => {
    const { bookId, part, page } = data;

    if (!bookId || !page || !part) {
        console.error('Can`t save progress state');
        return;
    }

    current = {
        bookId,
        part,
        page,
        timestamp: Date.now()
    };

    writeEditProgress();
};

export const writeEditProgress = () => {
    if (!current) return;

    localStorage.setItem(name(current.bookId), JSON.stringify(current));

    current = null;
};

export const getEditProgress = bookId => {
    if (current && current.bookId === bookId) return current;

    const item = localStorage.getItem(name(bookId));

    if (item) {
        current = JSON.parse(item);
        return { ...current };
    }

    return null;
};

const name = bookId => `sp-edit-progress-${bookId}`;
